import React, { useRef } from 'react';
import styled from 'styled-components';
import { Colors } from '@prezi/dragon';
import { Button, ThemeName } from '../Buttons';

const Textarea = styled.textarea`
    display: block;
    width: 100%;
    background-color: ${Colors.neutral80};
    border-radius: 4px;
    border-style: none;
    outline-style: none;
    padding: 5px 10px;
    margin-bottom: 20px;
    font-size: 14px;
    font-family: Courier, monospace;
`;

type Props = {
    linkUrl: string;
    buttonLabel: string | JSX.Element;
    buttonTheme?: ThemeName;
    rows?: number;
    onCopy?: (text?: string) => void;
};

const CopyTextArea = ({ linkUrl, buttonLabel, buttonTheme = 'blue', rows = 3, onCopy }: Props) => {
    const textarea = useRef<HTMLTextAreaElement>(null);
    const handleCopy = () => {
        if (textarea?.current) {
            textarea.current.select();
            document.execCommand('copy');
            if (onCopy) {
                onCopy(textarea.current.value);
            }
        }
    };

    return (
        <>
            <Textarea value={linkUrl} ref={textarea} rows={rows} readOnly data-lookup="copy-text-area-textarea" />
            <Button theme={buttonTheme} onClick={handleCopy} data-lookup="copy-text-area-button">
                {buttonLabel}
            </Button>
        </>
    );
};

export default CopyTextArea;
